import React, { useEffect, useState, Fragment } from 'react';
import { Pagination, PageHeader, paginate } from '../../../Common';
import { TableContent } from '../../Common/Table/tableContent';
 import services from '../services';
import { search, SearchFeild } from '../../Common';
import $ from 'jquery';
import { trackPromise } from 'react-promise-tracker';
import { LoadingSpinerComponent } from '../../../Common/loader'
import authService from '../../Common/services';


const screenCode = 'MOBILEMENU';

export function MenuListing(props){

    const [menu, setmenu] = useState([]);
    const [permissionList, setPermissions] = useState({
        isAddEditEnabled: false
    });

    const contentRowNames = ["menuCode", "menuName", "isActive"]
    useEffect(() => { 
        trackPromise(
            getPermissions()
        )
    }, []);


    async function getPermissions() { 
        var permissions = await authService.getPermissionsByScreen(screenCode);
         
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWMOBILEMENULISTING');

        if(isAuthorized === undefined){
            props.history.push('/unauthorized');
        }

        var isAddEditEnabled = permissions.find(p => p.permissionCode == 'ADDEDITMOBILEMENU');

        if(isAddEditEnabled != undefined){
            setPermissions({
                ...permissionList,
                isAddEditEnabled: true
            });
        }

        getAllMenu();
    }

    function destroyDataTable(){
        $('#example').DataTable().destroy();
    }

    function createDataTable(){
        $('#example').DataTable();
    }

    async function getAllMenu(){
         
        var data = await services.getAll()
        destroyDataTable()
        setmenu(data)
        createDataTable()
    }

    function handleClick(menu) {
        props.history.push({
            pathname: 'MobileMenu/addEdit',
            data: menu,
            edit: true
        })
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
        <div className="row">
            <div className="col-md-12">
                    <div className="card">
                        <PageHeader
                            title=" Mobile Menu "
                            isButtonEnable={permissionList.isAddEditEnabled}
                            buttonText="Add Menu"
                            path="MobileMenu/addEdit" />
                    <div className="card-body">
                      
                          
                       
                        <div className="table-responsive row-top-gap">
                            <table id="example" className="display dataTable no-footer">
                                <thead>
                                    <tr>
                                        <th>Menu Code</th>
                                        <th>Menu Name</th>
                                        <th>Status</th>
                                        { permissionList.isAddEditEnabled ? <th>Actions</th> : null }
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContent
                                        data={menu}
                                        contentRowNames={contentRowNames}
                                        hasEdit={permissionList.isAddEditEnabled}
                                        handleClick={handleClick} 
                                    />
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </Fragment>
    )
}


